import { useLayoutEffect } from 'react';

/** One physical Enter press advances exactly one step. Other controls keep their native keys. */
export function usePrimaryEnter(enabled: boolean) {
  useLayoutEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Enter' || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      const target = e.target instanceof HTMLElement ? e.target : null;
      if (target?.closest('[role="dialog"], [data-metric-help]')) return;
      if (e.repeat || e.isComposing || e.keyCode === 229) { e.preventDefault(); return; }
      if (target?.closest('input, textarea, select, [contenteditable="true"]')) return;
      const primary = document.querySelector<HTMLButtonElement>('[data-primary-action]');
      if (!primary || primary.disabled) return;
      if (target?.closest('button, a, summary, [role="button"]') && target !== primary && !target.closest('.choice')) return;
      e.preventDefault();
      e.stopPropagation();
      primary.click();
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [enabled]);
}
export function EnterHint() { return <kbd className="enter-hint" aria-hidden="true">Enter ↵</kbd>; }
